"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var firebase_1 = require("./firebase");
var Analyses = /** @class */ (function (_super) {
    __extends(Analyses, _super);
    function Analyses(orgId) {
        var _this = _super.call(this, "") || this;
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/" + _this.orgId + "/analyses/" + uid);
        };
        _this.getConfig = function (analysisId) {
            return _this.getByPath("/analyses_config/" + _this.orgId + "/" + analysisId);
        };
        _this.getAuthRoles = function (uid, analysisId) {
            return _this.getByPath("/users_mapping/" + _this.orgId + "/analyses/" + uid + "/" + analysisId);
        };
        _this.requestListMembers = function (orgId, uid, analysisId) {
            var request = {
                audit: {
                    createdBy: uid
                },
                analysisId: analysisId
            };
            return _this.create("/apis/" + orgId + "/" + uid + "/list_analysis_members", request);
        };
        _this.addUserToResource = function (orgId, uid, analysisId, userId) {
            var request = {
                audit: {
                    createdBy: uid
                },
                analysisId: analysisId,
                userId: userId
            };
            return _this.create("/apis/" + orgId + "/" + uid + "/add_user_to_analysis", request);
        };
        _this.orgId = orgId;
        return _this;
    }
    Analyses.prototype.deleteUserToResource = function (orgId, authUserId, analysisId, userId) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            analysisId: analysisId,
            userId: userId
        };
        return this.create("/apis/" + orgId + "/" + authUserId + "/deactivate_analysis_user", request);
    };
    ;
    Analyses.prototype.changePermissionToResource = function (orgId, authUserId, analysisId, userId, newAccountType) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            analysisId: analysisId,
            userId: userId,
            newAccountType: newAccountType
        };
        return this.create("/apis/" + orgId + "/" + authUserId + "/change_analysis_user_account_type", request);
    };
    ;
    Analyses.prototype.deleteResource = function (authUserId, resourceId) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            analysisId: resourceId
        };
        return this.create("/apis/" + this.orgId + "/" + authUserId + "/delete_analysis", request);
    };
    ;
    Analyses.prototype.updateName = function (resourceId, config) {
        config.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
        return this.update("/analyses_config/" + this.orgId + "/" + resourceId, config);
    };
    return Analyses;
}(Base_1.default));
exports.default = Analyses;
//# sourceMappingURL=Analyses.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Analyses.js
// module id = 358
// module chunks = 8